import { computed } from 'vue';
import { useInputStore } from '@/features/Sparten';
import { useGlobalStore } from '@/features/Global/store';
import { WKZ } from '@/features/Sparten/shared/types/kfz/types';
import { isPkwSparte } from '@/features/Sparten/shared/kfz/isPkwSparte';

export const currentWkz = computed(() => {
  if (isPkwSparte(useGlobalStore().getSparte)) {
    return WKZ.PKW;
  }

  return useInputStore().allgemein.wkz as WKZ;
});
